import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { FaInfoCircle, FaExclamationTriangle, FaTimesCircle, FaTimes } from "react-icons/fa";

const AlertModal = ({ userRole, onClose }) => {
  const [alertas, setAlertas] = useState([]);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const q = query(collection(db, "alertas"), where("activo", "==", true));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const now = new Date();
      const fetched = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter(
          (alerta) =>
            (!alerta.expiraEn || new Date(alerta.expiraEn.seconds * 1000) > now) &&
            (alerta.audiencia === "Todos" || alerta.audiencia === userRole)
        );
      setAlertas(fetched);
      setVisible(true);
    });

    return () => unsubscribe();
  }, [userRole]);

  if (!alertas.length || !visible) return null;

  const alerta = alertas[0];

  const styles = {
    informativa: {
      bg: "bg-gradient-to-br from-blue-100 to-blue-200",
      border: "border-blue-500",
      text: "text-blue-900",
      icon: <FaInfoCircle className="text-blue-600 text-4xl animate-bounce" />,
      button: "bg-blue-600 hover:bg-blue-700",
    },
    advertencia: {
      bg: "bg-gradient-to-br from-yellow-100 to-yellow-200",
      border: "border-yellow-500",
      text: "text-yellow-900",
      icon: <FaExclamationTriangle className="text-yellow-600 text-4xl animate-pulse" />,
      button: "bg-yellow-600 hover:bg-yellow-700",
    },
    critica: {
      bg: "bg-gradient-to-br from-red-100 to-red-200",
      border: "border-red-500",
      text: "text-red-900",
      icon: <FaTimesCircle className="text-red-600 text-4xl animate-shake" />,
      button: "bg-red-600 hover:bg-red-700",
    },
  };

  const defaultStyle = {
    bg: "bg-gradient-to-br from-gray-100 to-gray-200",
    border: "border-gray-500",
    text: "text-gray-900",
    icon: <FaInfoCircle className="text-gray-600 text-4xl animate-bounce" />,
    button: "bg-gray-600 hover:bg-gray-700",
  };

  const currentStyle = styles[alerta.tipo] || defaultStyle;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 p-4 md:p-6 lg:p-8 overflow-y-auto">
      <div
        className={`relative max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg w-full rounded-2xl shadow-2xl border-4 p-4 sm:p-6 md:p-8 animate-zoomIn ${currentStyle.bg} ${currentStyle.border} ${currentStyle.text}`}
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-2xl text-current hover:opacity-75 transition-opacity duration-300"
        >
          <FaTimes />
        </button>
        <div className="flex flex-col items-center text-center mb-4 sm:mb-6">
          {currentStyle.icon}
          <h1 className="text-2xl sm:text-3xl font-extrabold mt-2 sm:mt-4 uppercase tracking-wide">
            ¡Alerta!
          </h1>
        </div>
        <h2 className="text-xl sm:text-2xl font-bold mb-2 sm:mb-4 border-b-2 border-current pb-2">
          {alerta.titulo}
        </h2>
        <p className="mb-4 sm:mb-6 text-base sm:text-lg leading-relaxed">
          {alerta.mensaje}
        </p>
        <div className="flex justify-center">
          <button
            onClick={onClose}
            className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg text-white font-semibold shadow-md transition-transform duration-300 hover:scale-105 ${currentStyle.button}`}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;